import React, {Component} from 'react';
import {connect} from 'react-redux';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';
import axios from '../../axios-orders';
import * as actions from '../../store/actions/index';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
//import burger from '../../components/Burger/Burger'; also not used?




export class BurgerBuilder extends Component {
//in lieu of a constructor, just using modern syntax
state = {
    purchasing: false
}
componentDidMount() {
    // onInitIngredients
    this.props.onInitIngredients();
  
}

updatePurchaseState(ingredients) {
        /*     const ingredients = {
                ...this.state.ingredients
            }; */
    const sum = Object.keys(ingredients)
           .map( igKey => {
        return ingredients[igKey];
        })
        .reduce((sum, el) => {
            return sum + el;
        },0);
        return sum > 0;
}

/*     addIngredientHndlr = (type ) => {
        const oldCount  = this.state.ingredients[type];
        const updatedCount = oldCount + 1;
        const updatedIngredients = {
            ...this.state.ingredients
        };
        updatedIngredients[type] = updatedCount;
        const priceAddition = INGREDIENT_PRICES[type];
        const oldPrice = this.state.totalPrice;
        const newPrice = oldPrice + priceAddition;
        this.setState({totalPrice: newPrice, ingredients: updatedIngredients});
        // to run and enable order button
        this.updatePurchaseState(updatedIngredients);
    }

    removeIngredientHndlr  = (type) => {
        const oldCount  = this.state.ingredients[type];
        if (oldCount <= 0) {
            return;
        }
        const updatedCount = oldCount - 1;
        const updatedIngredients = {
            ...this.state.ingredients
        };
        updatedIngredients[type] = updatedCount;
        const priceDeduction = INGREDIENT_PRICES[type];
        const oldPrice = this.state.totalPrice;
        const newPrice = oldPrice - priceDeduction;
        this.setState({totalPrice: newPrice, ingredients: updatedIngredients});
        //to disable order button if all items removed
        this.updatePurchaseState(updatedIngredients);
    }
 */
purchaseHandler = () => {
    if (this.props.isAuthenticated) {
        this.setState({purchasing: true});
    }
    else {
        this.props.onSetAuthPathRedirect('/checkout');
        this.props.history.push('/auth');
    }
    
}


purchaseCxlHandler = () => {
    this.setState({purchasing: false});
}

purchaseContinueHandler = () => {
    //alert('Continue with Order! \n Bill $' + this.state.totalPrice +  ' to M/C?');
    //now, lect 278, with Redux, we can get rid of this query param method

          /*        const queryParams = [];
                     for (let i in this.state.ingredients) {
                        queryParams.push(encodeURIComponent(i) + '=' +  encodeURIComponent(this.state.ingredients[i]));
                        console.log(queryParams);
                    }
                    queryParams.push('price=' + this.state.totalPrice);
                    const queryString = queryParams.join('&'); */
                    this.props.onInitPurchase();
                    this.props.history.push('/checkout');
}


render () {
    //disable the button if nothing chosen
    const disabledInfo = {
          ...this.props.ings //becomes this.props.ings
    };
    for (let key in disabledInfo ) {
        disabledInfo[key] = disabledInfo[key] <= 0
    }
    let orderSummary = null;
    let burger = this.props.error ? <p>Ingredients can't be loaded!</p> : <Spinner />;
    //let burger = <Spinner />;

    if (this.props.ings) {
        burger =  ( 
        <Auxiliary>
        <Burger  ingredients={this.props.ings} /> 
        <BuildControls 
        ingredientAdded={this.props.onIngredientAdded}
        ingredientRemoved={this.props.onIngredientRemoved}
        disabled={disabledInfo}
        isAuth={this.props.isAuthenticated}
        purchasable={this.updatePurchaseState(this.props.ings)}
        ordered={this.purchaseHandler}
        price={this.props.price}
        />
        </Auxiliary> 
        );
        orderSummary =        
        <OrderSummary ingredients={this.props.ings}
       price={this.props.price}
       purchCanceled={this.purchaseCxlHandler}
       purchContinued={this.purchaseContinueHandler} />;
    }  

    return(
    <Auxiliary> 
        <Modal show={this.state.purchasing} modalClosed={this.purchaseCxlHandler}>
        {orderSummary}
       </Modal>
   {burger}
    </Auxiliary>
     );
   }
}

const mapStateToProps = state => {
    return {
        ings: state.burgerBuilder.ingredients,
        price: state.burgerBuilder.totalPrice,
        error: state.burgerBuilder.error,
        isAuthenticated: state.auth.token !== null
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onIngredientAdded: (ingName) => dispatch(actions.addIngredient(ingName)),
        onIngredientRemoved: (ingName) => dispatch(actions.removeIngredient(ingName)),
        onInitIngredients: () => dispatch(actions.initIngredients()),
        onInitPurchase:  () => dispatch(actions.purchaseInit()),
        onSetAuthPathRedirect: (path) => dispatch(actions.setAuthPathRedirect(path))
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (withErrorHandler(BurgerBuilder, axios));
